$('.default-slider').slick({
    arrows: false,
    dots: true,
    adaptiveHeight: true
})